import { render, staticRenderFns } from "./IpConfigStatic.vue?vue&type=template&id=0344a070&"
import script from "./IpConfigStatic.vue?vue&type=script&lang=js&"
export * from "./IpConfigStatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports